import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path1/components/LegalHeader.tsx");
